<div class="row" *ngIf="!hasLoadedOrder">
  <div class="col">
    <p class="alert alert-warning">
      <app-spin-icon></app-spin-icon>Loading order information...</p>
  </div>
</div>
<div class="row" *ngIf="hasLoadedOrder">
  <div class="col">
    <div class="row">
      <div class="col card card-cascade wider mb-3">
        <div class="view gradient-card-header primary-gradient white-text">
          <h1 class="h1-responsive">Thank you!</h1>
        </div>
        <div class="card card-body">
          <div class="row">
            <div class="col">
              <p>Your purchase is complete. Your order receipt is listed below for your information</p>
              <p *ngIf="isSingleCheckoutOrder && hasFinishedSingleOrderSetup" class="h6">
                You can now go back to your client or client list by clicking the Continue button.
                <input type='button' class="btn btn-primary" value="Continue" (click)="returnFromOrder()" />
              </p>
              <p *ngIf="isSingleCheckoutOrder && !hasFinishedSingleOrderSetup" class="h6">
                  Your assessments are now being setup for your client.  Please wait...
                  <input type='button' class="btn btn-primary" value="Continue"  disabled="disabled" />
                </p>
              <p *ngIf="!isSingleCheckoutOrder">Ready to use your purchased tokens?
                <input type='button' class="btn btn-primary" value="Manage your Clients" [routerLink]="['/admin', 'client']" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col card card-cascade wider">
        <div class="view gradient-card-header primary-gradient white-text">
          <h3 class="h3-responsive">Payment Receipt</h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col">
              <p *ngIf="!order" class="alert alert-danger">We're sorry your last payment could not be retrieved. contact customer support for assistance</p>
            </div>
          </div>
          <div class="row">
            <view-order class="col" *ngIf="order" [order]="order"></view-order>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/checkout-thankyou/checkout-thankyou.component.html